import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UploaderMessages } from '../../../shared/models/component-messages/uploader-messages';
import { ToastMessages } from '../../../shared/models/component-messages/toast-messages';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
})
export class UploadComponent implements OnInit {

  @Output() errorSizeEvent = new EventEmitter<string>();
  @Output() errorLengthEvent = new EventEmitter<string>();
  @Output() fileUpload = new EventEmitter<any>();
  @Output() deleteFileEvent = new EventEmitter<string>();
  @Output() validationMessageEvent = new EventEmitter<string>();
  @Input() filesToUpload;
  public uploadMessages = new UploaderMessages();
  public toastMessages = new ToastMessages();

  constructor(private toastr: ToastrService, private translate: TranslateService) {
  }

  public ngOnInit() {
  }

  public uploadOriginalFile(obj: any) {
    this.fileUpload.emit(obj);
    this.toastr.success(this.translate.instant(this.toastMessages.folder) + obj.file.name + this.translate.instant(this.toastMessages.load),
      this.translate.instant(this.toastMessages.successTitle));
  }

  public getValidationMessage(message) {
    this.validationMessageEvent.emit(message);
  }

  public getErrorSize(errorSize) {
    this.errorSizeEvent.emit(errorSize);
  }

  public getErrorLength(errorLength) {
    this.errorLengthEvent.emit(errorLength);
  }

  public deleteFile(obj) {
    this.deleteFileEvent.emit(obj);
  }
}

